/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Onboarding_Welcome_TitleInputs */



/**
* | output |
* | --- |
* | "Good to have you here, {name}." |
*
* @param {Onboarding_Welcome_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_welcome_title = /** @type {((inputs: Onboarding_Welcome_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Welcome_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Fijn dat je er bent, ${i?.name}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ravi de vous accueillir, ${i?.name}.`)
	return /** @type {LocalizedString} */ (`Good to have you here, ${i?.name}.`)
});